export const onConfirm = activationToken => ({
  widget: 'emailConfirm',
  type: 'onConfirm',
  payload: { activationToken },
})



// WEBPACK FOOTER //
// ./src/email-confirm/actions/onConfirm.js